// Tipos y helpers compartidos del Agente DIA (extraídos de AgenteDia.tsx, 2026-10-22).
export interface Item { id?: string; nombre: string; tipo: 'carpeta' | 'archivo'; ruta: string | null; size: number | null; webUrl?: string | null }
export interface Analisis {
  archivos: number; mb: number; imagenes: number; audios: number; muyGrandes: number;
  topeAlcanzado: boolean; subcarpetas: { nombre: string; archivos: number }[];
  estFase1Min: number; estFase2Min: number; at: string; faseInicio?: string;
}
export interface Favorito { id: string; nombre: string; ruta: string; tipo?: string; origen?: string | null; created_at: string; sync_estado?: string; sync_at?: string | null; docs_total?: number | null; docs_listos?: number | null; analisis?: Analisis | null   /** Ficha DIA (2026-10-22): resumen para los chips del listado; null si no hay ficha importada. */
  ficha?: { version: number; con: number; total: number; problemas: number } | null;
  capitulos_desactualizados?: number;
}

/** Raíz de los proyectos en SharePoint (solo lectura). */
export const RAIZ = 'Proyectos en desarrollo';

export const nf = new Intl.NumberFormat('es-CL');
/** Tramo final legible de una ruta larga de SharePoint. */
export const colaRuta = (ruta: string) => {
  const segs = ruta.split('/');
  return segs.length <= 2 ? ruta : `…/${segs.slice(-2).join('/')}`;
};
